import {
  Component, OnInit, OnDestroy, EventEmitter, Output, Input,
  ViewChild, ViewContainerRef, TemplateRef, OnChanges, AfterViewInit, SimpleChanges
} from '@angular/core';

import { Problem } from '../../models/problem';
import { DashboardView, ProblemType, MenuItem, SetProblemNeighborScope, LinkedCase, LinkedCaseDashboardChildren } from '../../state-management';
import { environment } from '../../../environments/environment';
import {
  IFilter, FilterSettingsModel, FilterEventArgs, GridComponent, TextWrapSettingsModel, RowDataBoundEventArgs,
  GridModel, DetailRowService, PageSettingsModel
} from '@syncfusion/ej2-angular-grids';

import { Tooltip } from '@syncfusion/ej2-popups';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-list-view',
    templateUrl: './list-view.component.html',
    styleUrls: ['./list-view.component.scss'],
    providers: [DetailRowService],
    standalone: false
})

export class ListViewComponent implements OnInit, OnChanges, OnDestroy {
  @Output() problemDetailsEmitter = new EventEmitter<string>();
  @Output() viewLoaded = new EventEmitter<boolean>();
  @Output() problemsFiltered = new EventEmitter<Problem[]>();
  @Output() problemSelected = new EventEmitter<string>();
  @Output() selectedProblemsToLink = new EventEmitter<Problem[]>();
  @Output() gridContentRefreshState = new EventEmitter<boolean>();
  @Input() dashboardView: DashboardView;
  @Input() problems: Problem[];
  @Input() noProblems: boolean;
  @Input() appView: string;
  @Input() problemTypes: MenuItem;
  @Input() clearFilterEvent: Observable<void>;
  @Input() showLinkProblemCol: boolean;
  @Input() lcm: LinkedCaseDashboardChildren[] = [];
  @Input() isRecentsView: boolean;

  prevShowLinkColVal = false;
  environment = environment;
  filter: IFilter;
  filterOptions: FilterSettingsModel;
  wrapSettings: TextWrapSettingsModel;
  sortSettings: object;
  sortSettingsDashboard: object;
  sortSettingsRecent: object;
  filteredProblemView: Problem[];
  problemsToLink: Problem[] = [];

  numLoadedLinkedCases = 0;
  childLinkedCases: GridModel = {};
  viewLoadedFired = false;

  @ViewChild('grid')
  public grid: GridComponent;
  private clearFilterSubscription: Subscription;
  public pageSettings: PageSettingsModel;

  constructor(private store: Store<{}>) { 
    // this.sortComparer.bind(this);
  }

  ngOnInit() {
    Object.keys(localStorage)
      .filter((key) => key.startsWith('gridgrid'))
      .map((key) => {
        const value = localStorage[key];
        const model = JSON.parse(value);
        delete model['columns'];    // remove the column from localStorage
        window.localStorage.setItem(key, JSON.stringify(model));
      });
    // const value = window.localStorage.getItem('gridgrid_1864281570_0'); //"gridGrid" is component name + component id.
    // const model = JSON.parse(value);
    // delete model['columns'];    // remove the column from localStorage
    // window.localStorage.setItem('gridgrid_1864281570_0', JSON.stringify(model));

    this.wrapSettings = { wrapMode: 'Content' };
    this.sortSettingsRecent = { columns: [{ field: 'lastViewedAt', direction: 'descending' }] };
    this.sortSettingsDashboard = { columns: [{ field: 'reportedDate', direction: 'descending' }] };
    this.sortSettings = this.isRecentsView ? this.sortSettingsRecent : this.sortSettingsDashboard;

    this.filterOptions = {
      type: 'Menu',
      operators: {
        stringOperator: [
          { value: 'contains', text: 'Contains' },
          { value: 'startsWith', text: 'Starts with' },
          { value: 'endsWith', text: 'Ends with' }
        ],
      }
    };
    
    this.filter = { type: 'CheckBox' };
    this.pageSettings = { pageSize: 15 };
    this.clearFilterSubscription = this.clearFilterEvent.subscribe(() => this.clearFilters());
  }

  // fixSortString(dateTime: string) {
  //   let dateAndTime = dateTime.split(" ");
  //   let date = dateAndTime[0];
  //   let time = dateAndTime[1];
  //   let timeSplit = time.split(":");

  //   let newTime: string[] = [];
  //   timeSplit.forEach(timeMeasure => {
  //     if (timeMeasure.length === 1) {
  //       newTime.push(`0${timeMeasure}`);
  //     } else {
  //       newTime.push(timeMeasure);
  //     }
  //   });

  //   let newDateTime = `${date} ${newTime.join(':')}`;
  //   return newDateTime;
  // }

  // sortComparer: (reference: string, comparer: string) => number = (reference: string, comparer:  string) => {
  //   let stringRef = this.fixSortString(reference);
  //   let stringCmp = this.fixSortString(comparer);

  //   if (stringRef < stringCmp) {
  //     return -1;
  //   }
  
  //   if (stringRef > stringCmp) {
  //     return 1;
  //   }

  //   return 0;
  // };

  ngOnDestroy() {
    this.clearFilterSubscription.unsubscribe();

    if (this.grid) {
      this.grid.destroy();
    }
  }

  load(args: object) {
    this.grid.allowKeyboard = false;
  }

  public actionComplete(args: FilterEventArgs): void {
    if (args.requestType === 'filtering') {
      // console.log(this.grid.currentViewData);
      this.filteredProblemView = this.grid.currentViewData as Problem[];
      this.problemsFiltered.emit(this.grid.currentViewData as Problem[]);
    }
    if (args.requestType === 'filterAfterOpen') {
      const inputs = this.grid.element.querySelectorAll('input.e-input');
      const datePick = Array.from(inputs).filter((i) => i.className.indexOf('e-datepicker') > -1);
      (datePick[0] as HTMLInputElement).placeholder = "Please use datepicker";
      (datePick[0] as HTMLInputElement).disabled = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.grid && !this.isRecentsView) {
      if (this.showLinkProblemCol && this.showLinkProblemCol !== this.prevShowLinkColVal) {
        this.prevShowLinkColVal = this.showLinkProblemCol;
        let gridColumnSize = 20;
  
        const windowWidth = window.innerWidth;
        if (windowWidth <= 1830) {
          // 1830 as that is the base width where the checkbox starts getting hidden
          // 95 is the scale factor where per 95 pixels in screen width decrease, we increase the grid column size by 1
          // goes up to a maximum of 34 as the minimum width of the display is 500px
          // add 5 pixels of padding
          const scaledWidthIncrease = (1830 - windowWidth) / 95;
          gridColumnSize += scaledWidthIncrease + 5;
        }
  
        (this.grid.columns[0] as any).width = `${gridColumnSize}`;
        this.grid.refreshColumns();
  
      } else if (!this.showLinkProblemCol && this.showLinkProblemCol !== this.prevShowLinkColVal) {
        this.prevShowLinkColVal = this.showLinkProblemCol;
        (this.grid.columns[0] as any).width = '1';
        this.grid.refreshColumns();
      }
    }

    if (changes.lcm && changes.lcm.currentValue !== null && changes.lcm.currentValue !== changes.lcm.previousValue) {
      this.childLinkedCases = {
        dataSource: this.lcm,
        queryString: 'problemNo',
        rowDataBound: this.childRowDataBound,
        rowSelected: this.childRowClick.bind(this),
        columns: [
          { field: 'childProblemNo', width: 120 },
          { field: 'priority', width: 80 },
          { field: 'reportedDate', width: 100 },
          { field: 'problemType_Name', width: 200 },
          { field: 'problemLocation', width: 180 },
          { field: 'problemStatus', width: 80 },
          { field: 'assignedTo', width: 150 }
        ]
      };

      this.gridContentRefreshState.emit(this.grid ? false : true);
    }

    if ((this.problems.length > 0 || this.noProblems === false) && !this.viewLoadedFired) {
      this.viewLoaded.emit(true);
      this.viewLoadedFired = true;
    }
  }

  formatDateTime(problem: Problem) {
    console.log(problem.lastViewedAt);
  }

  getAssignee(problem: Problem) {
    if (problem.assignedTo?.length > 0) {
      return problem.assignedTo;
    }

    if (problem.problemRole?.length > 0) {
      return problem.problemRole;
    }

    return problem.problemGroup;
  }

  toDetails(problemNum: string) {
    this.problemDetailsEmitter.emit(problemNum);
  }

  handleCheckboxChecked(problemNo: string) {
    return this.problemsToLink.some(problem => problem.problemNo === problemNo);
  }

  headerCellInfo(event: any) {
    if (event.cell.column.field !== 'problemLink') {
      const toolcontent = event.cell.column.headerText;
      const tooltip: Tooltip = new Tooltip({
        content: toolcontent
      });
      tooltip.appendTo(event.node);
    }
  }

  rowClick(event: any) {
    if (event.isInteracted && event.target.type !== 'checkbox') {
      const problemNeighborScope: string[] = [];
      this.filteredProblemView.forEach(problem => problemNeighborScope.push(problem.problemNo));
      this.store.dispatch(new SetProblemNeighborScope({ problemNeighborScope: problemNeighborScope }));

      const problemNo: string = event.data.problemNo;
      this.problemSelected.emit(problemNo);
    }
  }

  clearFilters() {
    this.grid.clearFiltering();
    this.grid.clearSorting();
  }

  dataInitialized() {
    // console.log(this.grid.currentViewData);
    this.filteredProblemView = this.grid.currentViewData as Problem[];
    this.problemsFiltered.emit(this.grid.currentViewData as Problem[]);
  }

  childRowClick(event: any) {
    if (event.isInteracted) {
      const problemNeighborScope: string[] = [];
      const parentNumber = event.data.problemNo;
      const children = this.lcm.filter(linkedCase => linkedCase.problemNo === parentNumber);

      children.forEach(child => problemNeighborScope.push(child.childProblemNo));
      this.store.dispatch(new SetProblemNeighborScope({ problemNeighborScope: problemNeighborScope }));

      const problemNo: string = event.data.childProblemNo;
      this.problemSelected.emit(problemNo);
    }
  }

  childRowDataBound(args: any) {
    if (args.data.problemRead === 'New' || args.data.assignedTo === 'Unassigned') {
      args.row.children[0].innerHTML = args.data.childProblemNo + ' <label class="new-Problem">New</label>';
    }

    args.row.children[0].innerHTML = '<i class="fas fa-level-down-alt" data-fa-transform="rotate-90 flip-h"></i>' +
      args.row.children[0].innerHTML;
  }


  rowDataBound(args: any) {
    if (this.lcm && this.lcm.length > 0) {
      const hasLinkedCase = this.lcm.some(linkedCase => linkedCase.problemNo === args.data.problemNo);
      if (!hasLinkedCase) {
        args.row.children[0].innerHTML = '';
      }
    } else {
      // child grid datasource not ready, hide down arrows
      args.row.children[0].innerHTML = '';
    }


    if (args.data.problemRead === 'New' || args.data.assignedTo === 'Unassigned') {
      // args.row.children[1].innerHTML = args.data.problemNo + ' <label class="new-Problem">New</label>';
      args.row.children[2].innerHTML = args.data.problemNo + ' <label class="new-Problem">New</label>';
    }
  }

  handleProblemSelect(event: any) {
    if (event.target.checked) {
      const problemToLink = this.problems.filter(problem => problem.problemNo === event.target.value)[0];
      this.problemsToLink.push(problemToLink);
    } else {
      this.problemsToLink = this.problemsToLink.filter(problem => problem.problemNo !== event.target.value);
    }

    this.selectedProblemsToLink.emit(this.problemsToLink);
  }
}
